<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-form ref="meetForm" v-model="formValid">
          <v-layout wrap>
            <v-flex xs12>
              <h3 class="delimiter_text">General info</h3>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model.trim="meetData.meetName"
                label="Meet name"
                :rules="nameRules"
                :counter="50"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model.trim="meetData.urlToDetails"
                label="Url to event details"
                hint="Meeting creators website"
                persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model.trim="meetData.contactInfo"
                label="Contact info"
                hint="Any contacts of the creators of the meeting"
                :rules="requiredRule"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model.trim="meetData.meetDesc"
                label="Meet description"
                :rules="requiredRule"
              ></v-textarea>
            </v-flex>
            <!--TODO Change to reusable select league seqno-->
            <v-flex xs12 sm6>
              <v-select
                v-model="meetData.leagueSeqno"
                :items="leagueList"
                outlined
                hide-details
                dense
                label="League"
                item-value="node.seqno"
                item-text="node.name"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                outlined
                hide-details
                dense
                :items="['active', 'inactive']"
                v-model="meetData.state"
                label="State"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <catValueDropDown
                :outlined="true"
                label="Sport type"
                catName="SPORT_TYPE"
                v-model.trim="meetData.sport"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <catValueDropDown
                :rules="requiredRule"
                :outlined="true"
                label="Meet type"
                catName="MEET_TYPE"
                v-model.trim="meetData.meetType"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <catValueDropDown
                :outlined="true"
                label="Tags"
                catName="MEET_TAGS"
                v-model.trim="meetData.tag"
                :multiList="true"
              />
            </v-flex>
            <v-flex xs11>
              <FacilitySection
                :currentFacility="meetData.facilityId"
                @facility-changed="meetData.facilityId = $event"
              />
            </v-flex>
            <v-flex xs12>
              <h3 class="delimiter_text">Time details</h3>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model.trim="meetData.meetDate"
                    :rules="requiredRule"
                    label="Meet date"
                    prepend-icon="event"
                    v-on="on"
                    v-bind="attrs"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model.trim="meetData.meetDate"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                :rules="requiredRule"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model.trim="meetData.meetDateTo"
                    label="Meet date to"
                    prepend-icon="event"
                    v-on="on"
                    v-bind="attrs"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model.trim="meetData.meetDateTo"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" text @click="close">Cancel</v-btn>
      <v-btn :disabled="!formValid" color="secondary" text @click="actionName"
        >Save</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import { meetDefaultData } from "@/constants/tabelsData";
import { validationRules } from "@/constants/global";
//TODO Fix filter problem in component below
import catValueDropDown from "../shared/cat_val_dropdown.vue";
import FacilitySection from "@/components/shared/FacilitySection.vue";
import { mapGetters, mapActions } from "vuex";
import { hasJsonStructure } from "@/_helpers/index";
import { OpenStreetMapProvider } from "leaflet-geosearch";

export default {
  components: { catValueDropDown, FacilitySection },
  props: {
    formTitle: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    editData: {
      type: [Boolean, Object]
    }
  },
  data() {
    return {
      searchLoading: false,
      search: null,
      formValid: true,
      menu1: false,
      menu2: false,
      address: [],
      meetData: {
        meetName: "",
        meetDesc: "",
        contactInfo: "",
        meetType: "",
        meetDate: "",
        meetDateTo: "",
        facilityId: "",
        sport: "",
        urlToDetails: "",
        state: "",
        tag: [],
        leagueSeqno: 0, // Selected element has type string
        updateSource: "test"
      },
      defaultMeetData: meetDefaultData,
      nameRules: validationRules.name,
      requiredRule: validationRules.required
    };
  },
  methods: {
    ...mapActions(["addNewMeet", "editCurrentMeet"]),
    close() {
      this.meetData = Object.assign({}, this.defaultMeetData);
      this.$emit("close-form");
    },
    /**
     * @param {Object || boolean}
     */
    setMeetData(data) {
      if (data) {
        if (data.tag && hasJsonStructure(data.tag)) {
          data.tag = JSON.parse(data.tag);
        }

        this.meetData = { ...this.defaultMeetData, ...data };
      }
    },
    validateForm() {
      this.$refs.meetForm.validate();
    },
    addMeet() {
      console.log(this.meetData);
      this.$emit("set-loading", true);
      if (this.formValid) {
        // const leagueBySeqno =
        //   this.$store.state["Leagues"].leagues.filter(
        //     l => +l.node.seqno === this.meetData.leagueSeqno
        //   )[0] || {};
        this.addNewMeet({
          ...this.meetData,
          leagueSeqno: Number(this.meetData.leagueSeqno),
          userId: +this.$store.getters.user.userId,
          // league: leagueBySeqno || {},
          tag:
            this.meetData.tag.length > 0
              ? JSON.stringify(this.meetData.tag)
              : this.meetData.tag
        })
          .then(() => {
            this.$toast.success(`${this.meetData.meetName} has been added`);
            this.$emit("set-loading", false);
            this.close();
          })
          .catch(error => {
            console.error(error);
            this.$emit("set-loading", false);
            this.close();
          });
      } else {
        this.$emit("set-loading", false);
        this.validateForm();
      }
    },
    editMeet() {
      this.$emit("set-loading", true);
      if (this.formValid) {
        this.editCurrentMeet({
          ...this.meetData,
          meetId: this.meetData.meetId ? parseInt(this.meetData.meetId, 10) : 0,
          leagueSeqno: Number(this.meetData.leagueSeqno),
          tag:
            this.meetData.tag && this.meetData.tag.length > 0
              ? JSON.stringify(this.meetData.tag)
              : this.meetData.tag
        })
          .then(() => {
            this.$emit("set-loading", false);
            this.$toast.info(`${this.meetData.meetName} meet has been updated`);
            this.close();
          })
          .catch(error => {
            console.error(error);
            this.$emit("set-loading", false);
            this.close();
          });
      } else {
        this.$emit("set-loading", false);
        this.validateForm();
      }
    }
  },
  async created() {
    await this.$store.dispatch("getAllLeagues");
  },
  mounted() {
    // ? Mounted hook can catch first update of editData
    this.setMeetData(this.dataToEdit);
  },
  watch: {
    dataToEdit() {
      this.setMeetData(this.dataToEdit);
    },
    // currentAddress(val) {
    //   if (val && val.display_name !== null) {
    //     this.meetData.meetAddress = val.display_name;
    //     this.meetData.latitude = val.lat;
    //     this.meetData.longitude = val.lon;
    //     console.log(val);
    //   }
    // },
    search(val) {
      // Items have already been loaded
      // if (this.address.length > 0) return;

      this.searchLoading = true;
      const provider = new OpenStreetMapProvider();
      provider
        .search({
          query: val
        })
        .then(data => {
          this.address = data;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.searchLoading = false;
        });
    }
  },
  computed: {
    ...mapGetters(["categoryValue"]),
    /**
     * @return {Object || Boolean}
     */
    dataToEdit() {
      if (this.editData && typeof this.editData !== "boolean") {
        return this.editData;
      } else {
        return false;
      }
    },
    //TODO Take out this logic to helper file
    // countryList() {
    //   if (this.categoryValue.edges) {
    //     return this.categoryValue.edges.filter(
    //     );
    //   } else {
    //     return [];
    //   }
    // },
    meetTypes() {
      return this.categoryValue.edges
        ? this.categoryValue.edges.filter(
            c => c.node.category.catName === "MEET_TYPE"
          )
        : [];
    },
    leagueList() {
      return this.$store.getters.getLeagues || [];
    },
    /**
     * @return {Function}
     */
    actionName() {
      return this.index > 0 ? this.editMeet : this.addMeet;
    }
  }
};
</script>
